/**
 * @generated SignedSource<<e823476b84c438a45771a4dc39ab805e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NativeIssueTableWithSelectedIssuesProvider$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ColumnConfigWithContainer_savedViewId" | "IssueTableIssueTable">;
  readonly " $fragmentType": "NativeIssueTableWithSelectedIssuesProvider";
};
export type NativeIssueTableWithSelectedIssuesProvider$key = {
  readonly " $data"?: NativeIssueTableWithSelectedIssuesProvider$data;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NativeIssueTableWithSelectedIssuesProvider",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ColumnConfigWithContainer_savedViewId"
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueTableIssueTable"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "187425a6602b2816d5481a2bd973ae1d";

export default node;
